import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const reorderDiscountRules = {
  name: "reorderDiscountRules" as const,
  input: z.object({ ruleIds: z.array(zExt.objectId()) }),
  output: z.null(),
};
